import {jwtDecode} from 'jwt-decode';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Navigate, Outlet} from 'react-router-dom';

import {selectAuth} from '../../../redux/selectors';

const ProtectedRoute = ({allowedRoles}) => {
  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const decodedToken = token ? jwtDecode(token) : {};

  const role = decodedToken?.role;

  if (!auth.loggedIn) {
    return <Navigate to={'/auth/login'} replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to={'/unauthorized'} replace />;
  }

  return <Outlet />;
};

ProtectedRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ProtectedRoute;
